export default __webpack_public_path__ + "static/0041-55f209dfb07fee51eb1a27b97d240016.png";